import React from 'react';
import { CTAButton } from './CTAButton';
export function FinalCTASection() {
  return <section id="final-cta-section" className="w-full bg-bg-primary py-16 md:py-24 px-4" data-id="element-30">
      <div className="max-w-6xl mx-auto" data-id="element-31">
        <div className="bg-gradient-to-br from-bg-section to-bg-card rounded-2xl p-8 md:p-12 lg:p-16 border border-cta/20" data-id="element-32">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center" data-id="element-33">
            <div data-id="element-34">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 md:mb-6" data-id="element-35">
                Construye la infraestructura completa de tu empresa
              </h2>
              <p className="text-base md:text-xl text-text-secondary leading-relaxed mb-6 md:mb-8" data-id="element-36">
                Deja de operar con vulnerabilidades. Implementa el sistema de 4
                pilares y domina tu empresa desde el primer día.
              </p>

              <CTAButton showPrice={true} data-id="element-37" />

              <div className="mt-6 md:mt-8 pt-6 md:pt-8 border-t border-text-secondary/10" data-id="element-38">
                <div className="flex flex-wrap gap-4 md:gap-6 text-xs md:text-sm text-text-secondary" data-id="element-39">
                  <div className="flex items-center gap-2" data-id="element-40">
                    <svg className="w-4 h-4 md:w-5 md:h-5 text-cta" fill="currentColor" viewBox="0 0 20 20" data-id="element-41">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-42" />
                    </svg>
                    <span data-id="element-43">Descarga inmediata</span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-44">
                    <svg className="w-4 h-4 md:w-5 md:h-5 text-cta" fill="currentColor" viewBox="0 0 20 20" data-id="element-45">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-46" />
                    </svg>
                    <span data-id="element-47">Formato PDF</span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-48">
                    <svg className="w-4 h-4 md:w-5 md:h-5 text-cta" fill="currentColor" viewBox="0 0 20 20" data-id="element-49">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-50" />
                    </svg>
                    <span data-id="element-51">Sistema completo</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex justify-center lg:justify-end" data-id="element-52">
              <img src="https://cdn.magicpatterns.com/uploads/9e5aqW53oEvCc8HSyPBvDP/emprende_USA_Express2.png" alt="EMPRENDE USA EXPRESS" className="w-full max-w-xs md:max-w-md" data-id="element-53" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}